<div class="containerDialog">
  <h3 *ngIf="operationType !== 'VAL'" class="declineTitle">{{ 'signaturit_pro.document.decline_signa' | translate}}</h3>
  <h3 *ngIf="operationType === 'VAL'" class="declineTitle">{{ 'signaturit_pro.document.decline' | translate}}</h3>
  <div *ngIf="rejectionReasons.length > 0" class="mb-3">
    <p class="declineText">{{ 'signaturit_pro.document.select_rejection_reason' | translate}}</p>
    <mat-radio-group class="radio-group-vertical" [(ngModel)]="selectedReasonId" aria-label="Selecciona un motivo de rechazo">
      <mat-radio-button class="radio-option" *ngFor="let reason of rejectionReasons" [value]="reason.Id">{{
        reason.Description }}</mat-radio-button>
    </mat-radio-group>
  </div>
  <p *ngIf="rejectionReasons.length == 0" class="mb-3" class="declineText">{{ 'signaturit_pro.document.decline_message'
    | translate}}</p>
  <div *ngIf="rejectionReasons.length == 0">
    <textarea class="areaDecline" maxlength="255" [(ngModel)]="declineText"></textarea>
  </div>
  <div *ngIf="rejectionReasons.length > 0">
    <textarea [placeholder]="'signaturit_pro.document.add_additional_reason' | translate" class="areaDecline" maxlength="255" [(ngModel)]="declineText"></textarea>
  </div>
  <div class="buttonBar">
    <signaturit-button text="{{'areas.cancel_delete' | translate}}" type="auxiliar" size="md" (click)="close()">
    </signaturit-button>
    <signaturit-button text="{{'areas.confirm_delete' | translate}}" [showLoader]="isLoading"
      [disabled]="rejectionReasons.length == 0 ? declineText.length < 1 || isLoading : !selectedReasonId || isLoading" type="primary" size="md" (click)="cancel()">
    </signaturit-button>
  </div>
</div>